import type { UnlikelyCollection } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { getMarket } from "~/lib/i18n/utils/get-i18n"
import { getCollectionMetafieldValue } from "~/lib/shopify/constants"
import { excludeFiltersByMarketSchema } from "~/lib/shopify/metaobjects/exclude-filters-by-market"
import { getMetaObjects } from "~/lib/shopify/metaobjects/get"
import { parseShopifyReferencesFromMetatield } from "~/lib/shopify/utils/parse-references-from-metafields"

export async function getIncludedFiltersByMarket(
  collection: Pick<UnlikelyCollection, "filters" | "metafields">,
  locale: Nullish<string>
) {
  const excludedFiltersByMarkets = parseShopifyReferencesFromMetatield(
    getCollectionMetafieldValue(collection?.metafields, "EXCLUDED_FILTERS_BY_MARKETS")
  )

  const excludedFiltersMetaobjects = await getMetaObjects(
    excludedFiltersByMarkets,
    excludeFiltersByMarketSchema,
    locale
  )

  const market = getMarket(locale)

  const excludedFiltersByMarket = excludedFiltersMetaobjects.reduce<string[]>((acc, { markets, filters }) => {
    if (markets?.includes(market) && filters) {
      acc.push(...filters)
    }

    return acc
  }, [])

  return collection.filters.map((filter) => {
    return {
      ...filter,
      values: filter.values.filter((value) => !excludedFiltersByMarket.includes(value.label ?? "")),
    }
  })
}
